import { useState, createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  getNotificationsUserService,
  readNotificationUserService,
  readAllNotificationUserService,
  deleteNotificationUserService,
  deleteAllNotificationUserService,
} from "../../../services/userServices";
import { setMetaAction } from "../../../redux/actions/metaActions/metaActions";

export const notificationUserContext = createContext({
  notifications: [],
  setNotifications: () => {},
  notification: {},
  setNotification: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetNotifications: () => {},
  handleReadNotification: () => {},
  handleReadAllNotification: () => {},
  handleDeleteNotification: () => {},
  handleDeleteAllNotification: () => {},
});

const NotificationUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);
  const [notification, setNotification] = useState({});
  const [sort, setSort] = useState("");
  const [filter, setFilter] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);

  // Get Notifications
  const handleGetNotifications = async (event) => {
    event?.preventDefault();

    const objData = {
      filter,
      pageNumber,
      sort,
      itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getNotificationsUserService(objData);
      if (status === 200) {
        setNotifications(data.result?.notifications);
        setPageCount(data?.result?.allPagesCount);
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Read Notification
  const handleReadNotification = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await readNotificationUserService(id);
      if (status === 200) {
        handleGetNotifications();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Read All Notification
  const handleReadAllNotification = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await readAllNotificationUserService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetNotifications();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Notification
  const handleDeleteNotification = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteNotificationUserService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetNotifications();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete All Notification
  const handleDeleteAllNotification = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteAllNotificationUserService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetNotifications();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <notificationUserContext.Provider
      value={{
        notifications,
        setNotifications,
        notification,
        setNotification,
        filter,
        setFilter,
        sort,
        setSort,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetNotifications,
        handleReadNotification,
        handleReadAllNotification,
        handleDeleteNotification,
        handleDeleteAllNotification,
      }}
    >
      {children}
    </notificationUserContext.Provider>
  );
};

export default NotificationUserContext;
